import {CloudyOutline} from "react-ionicons";

export default function CloudIcon() {
  return (
    <CloudyOutline color="var(--color-secondary)" />
  )
}
